module.exports = __webpack_public_path__ + "static/img/17b.3d96744.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/17b.jpg
// module id = /GDk
// module chunks = 1